import { Component } from '@angular/core';
import { UserType } from '../../../Shared/Enums/UserType';
import { Router } from '@angular/router';
import { AuthService } from '../../../Shared/Services/auth.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { ClientService } from '../../../Services/client.service';
@Component({
  selector: 'app-submit-contract-warranty',
  templateUrl: './submit-contract-warranty.component.html',
  styleUrl: './submit-contract-warranty.component.scss'
})
export class SubmitContractWarrantyComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  ContractsList!: DtoContractClientForViewVM[];
  AllClients: DtoClientForViewVM[] = [];
  selectedClient?: DtoClientForViewVM;
  selectedContract?: DtoContractClientForViewVM;
  isCreateContract: boolean = false;
  isChooseContract: boolean = false;

  constructor(private contractApi: ContractsWarrantiesService, private clientApi: ClientService,
    private auth: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.GetAllClients();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  tabClick(tab: any) {
    this.spinner.show();
    if (tab.index == 0) {
      this.GetAllClients();
    }
    else if (tab.index == 1) {
      this.GetAllContracts();
    }
  }

  GetAllContracts() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.contractApi.GetAllContracts()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.ContractsList = data.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllClients() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.clientApi.GetAllClients()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllClients = res.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  CheckIfCreateContract(isCreateContract: boolean) {
    this.isCreateContract = isCreateContract;
  }

  GetSelectedClient(client?: DtoClientForViewVM) {
    this.selectedClient = client;
  }

  GetSelectedContract(contract?: DtoContractClientForViewVM) {
    this.selectedContract = contract;
  }

  CheckIfChooseContract(isChooseContract: boolean) {
    this.isChooseContract = isChooseContract;
  }
}
